import { RootState } from '../store'

export const groupsStates = (state: RootState) => state.groups
